import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, Validator } from '@angular/forms';


@Directive({
  selector: '[appPasswordComplexity]',
  providers: [{provide: NG_VALIDATORS, useExisting: PasswordComplexityValidatorDirective, multi: true}]
})

/**
 * Custom password complexity validator
 * Checks that the password has at least one uppercase character, one lowercase character and one digit
 */
export class PasswordComplexityValidatorDirective implements Validator {

  validate(control: AbstractControl) {
    let password = control.value;

    // Rule 1 - has at least one uppercase character
    let regexpUppercase = new RegExp('[A-Z]');
    if (!regexpUppercase.test(password)) {
      return {passwordComplexity: 'The password must contain at least one uppercase letter.'};
    }

    // Rule 2 - has at least one lowercase character
    let regexpLowercase = new RegExp('[a-z]');
    if (!regexpLowercase.test(password)) {
      return {passwordComplexity: 'The password must contain at least one lowercase letter.'};
    }

    // Rule 3 - has at least one numbers
    let regexpNumber = new RegExp('[0-9]');
    if (!regexpNumber.test(password)) {
      return {passwordComplexity: 'The password must contain at least one number.'};
    }

    // Matches password complexity rules - return null
    return null;
  }
}
